import { Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isTruthy } from 'common';

import { useFlowDefinitionContext } from '../../../../context.ts';
import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate.tsx';
import { BlockSelectField } from '../../ConfigFields/SelectField.tsx';

export function GetSftpFileFormFields() {
  const {
    flowDefinition: { organizationId },
  } = useFlowDefinitionContext();
  const { data: servers = [] } = useQuery({
    ...getQueryProps(api.client.Sftp, 'findAllByOrganizationId', organizationId),
    enabled: isTruthy(organizationId),
  });

  return (
    <Stack direction="column" spacing={2}>
      <BlockSelectField
        options={servers.map((s) => ({ label: s, value: s }))}
        fieldName="config.server"
        label="Server"
      />
      <BlockValueTemplateField fieldName="config.path" label="File Path" />
    </Stack>
  );
}
